export const PLANT = 'plant';
export const PLANT_15 = 'plant15';
export const RAT = 'rat';
